import { Component, ElementRef, HostListener, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ReportingTemplate } from 'src/app/core/models/rulebook/reporting-template-model';
import { GDPRService } from 'src/app/core/services/rulebook';
import { Location } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HtmlPipe } from 'src/app/views/shared/pipe/html.pipe';
import { ActivatedRoute } from '@angular/router';
import { RegulationService } from 'src/app/core/services/regulation';
import { Tooltip } from 'primeng/tooltip';
import { ChangeDetailComponent } from '../../change-detail/change-detail.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-reporting-templates',
  templateUrl: './reporting-templates.component.html',
  styleUrls: ['./reporting-templates.component.scss'],
  providers: [HtmlPipe],
})
export class ReportingTemplatesComponent implements OnInit {
  isLoadingMain = false;
  reportingTemplateDetails: ReportingTemplate[] = [];
  reportTemplateUrl: string;
  templateNo: number = 0;
  reportTemplateHeader: ReportingTemplate[] = [];
  reportTemplateData: ReportingTemplate[] = [];
  templateName: string = '';
  structuredData = [];
  applyColor = true;
  tooltipText = '';
  selectedRulebookId = 0;
  isShowingTooltip: boolean = false;
  tooltipContent: string = '';
  @ViewChildren(Tooltip) tooltips!: QueryList<Tooltip>;
  lastTooltipId!: number;
  @ViewChild('tooltipTrigger') tooltipTrigger!: ElementRef;
  isToolOpen = false;
  selectedReportId = 0;

  //For PrimeNg
  headers: string[] = [];
  rows: any[] = [];

  constructor(
    private gdprService: GDPRService,
    private location: Location,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private regulationService: RegulationService,
    private dialog: MatDialog,
  ) {
    this.reportTemplateUrl = this.location.path();
  }
  ngOnInit(): void {
    let template = this.route.snapshot.params.id;
    this.templateNo = parseInt(template, 10);
    this.getReportingTemplateDetail(this.templateNo);
  }

  ngAfterViewInit() {
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        const foundTooltip = this.findTooltipById(this.selectedReportId.toString());
        if (foundTooltip) {
          if (foundTooltip.active) {
            foundTooltip.deactivate();
            this.isShowingTooltip = false;
          }
        }
      }
    });
  }

  getReportingTemplateDetail(id: number): void {
    this.gdprService
      .getReportingTemplateDetailsById(id)
      .subscribe((data: ReportingTemplate[]) => {
        this.reportingTemplateDetails = data;
        if (this.reportingTemplateDetails.length > 0) {
          this.headers = this.reportingTemplateDetails
            .filter((item) => item.type === 'TableHeader')
            .map((item) => item.columnName);

          const rowData = this.reportingTemplateDetails.find(
            (item) => item.type === 'Data'
          );
          if (rowData) {
            const rowDataObj = JSON.parse(rowData.columnName);
            this.rows.push(rowDataObj);
          }
          this.reportTemplateData = this.reportingTemplateDetails.filter(
            (item) => item.type === 'Data'
          );
          let jsonData = JSON.parse(this.reportTemplateData[0].columnName);
          this.structuredData = jsonData;
        }
      });
  }
  // getTooltipData(rulebookId:any){
  //   if(rulebookId){
  //     this.showTooltip = true;
  //     this.selectedRulebookId = rulebookId;
  //     this.description = '';
  //     this.regulationService.getDescriptionById(rulebookId.toString()).subscribe((data:any)=>{
  //       this.description = data.result;
  //       this.tooltipContent = this.description;
  //     });
  //   }
  // }
  // getTooltipContent(rulebookId: number): string {
  //   if (rulebookId === this.selectedRulebookId) {
  //     return this.description;
  //   } else {
  //     return '';
  //   }
  // }
  //tooltip code
  private findTooltipById(searchId: string): Tooltip | undefined {
    return this.tooltips.find(
      (tooltip) => tooltip.el.nativeElement.id === searchId
    );
  }

  getTooltipData(regulator: number) {
    if (regulator) {
      const foundTooltip = this.findTooltipById(regulator.toString());
      if (foundTooltip) {
        if (foundTooltip.active) {
          foundTooltip.deactivate();
          this.isShowingTooltip = false;
        } else {
          if (this.isShowingTooltip) {
            const lastfoundTooltip = this.findTooltipById(
              this.lastTooltipId.toString()
            );
            if (lastfoundTooltip) {
              lastfoundTooltip.deactivate();
            }
          }
          foundTooltip.activate();
          // this.isShowingTooltip = true;
          this.lastTooltipId = regulator;
          this.getDescription(regulator);
        }
      }
    }
  }

  getDescription(regulator: number) {
    this.regulationService
      .getDescriptionById(regulator.toString())
      .subscribe((data: any) => {
        if (data.result) {
          this.tooltipText = data.result;
          this.isShowingTooltip = true;
          this.selectedReportId = regulator;
        } else {
          this.tooltipText = 'No Description Found';
        }
      });
  }
  openView(id: number, detailType: number) {
    const dialogRef = this.dialog.open(ChangeDetailComponent, {
      width: '1800px',
      height: '870px',
      data: {
        id: id,
        detailType: detailType,
        ruleArr: null,
        filterType: 'All',
        type: 'modal',
      },
    });
  }
}
